import { render, staticRenderFns } from "./accidentInfo.vue?vue&type=template&id=50b2ab56&scoped=true&"
import script from "./accidentInfo.vue?vue&type=script&lang=js&"
export * from "./accidentInfo.vue?vue&type=script&lang=js&"
import style0 from "./accidentInfo.vue?vue&type=style&index=0&id=50b2ab56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b2ab56",
  null
  
)

export default component.exports